export class ShipmentStatusRequest{
    unitId?:number;
    saleOrderId?:number;
    masterBrandId?:number;
    selectedLoadingFromDate?:any;
    selectedLoadingToDate?:any;
}